//EXTERNAL
import React from "react";
//COMPONENTS
import AuthorizedLayout from "../layout/AuthorizedLayout";
import UnAuthorizedLayout from "../layout/UnAuthorizedLayout";
//HOOKS
import has_ad_blocker from "../hooks/has_ad_blocker";
//CONTEXT
import { useUserState } from "../contexts/user.context";
import { useNotificationDispatch } from "../contexts/notification.context";
//FEATURES
import { Help } from "../features/notifications/help";
//TYPES
type Props = { children: React.ReactNode };

export default function Layout({ children }: Props) {
  const user = useUserState();
  const notificationDispatch = useNotificationDispatch();

  /* Check whether user has ad blocker enabled */
  const adBlocker = () => {
    const hasAdBlocker = has_ad_blocker();
    if (hasAdBlocker) {
      return notificationDispatch({
        type: "ADD",
        payload: {
          header: "Ad Blocker",
          message: "Please disable your adblocker.",
          type: "info",
          autoDismiss: false,
        },
      });
    }
  };

  return (
    <>
      <div className="picnic-font text-size-2 platform-background-platform-background-3" style={{ minWidth: "1400px" }}>
        {user.isAuthenticated ? (
          <AuthorizedLayout>
            <Help />
            {adBlocker()}
            {children}
          </AuthorizedLayout>
        ) : (
          <UnAuthorizedLayout>{children}</UnAuthorizedLayout>
        )}
      </div>
    </>
  );
}
